import {setCacheNameDetails as workbox_core_setCacheNameDetails} from '/opt/build/repo/node_modules/workbox-core/setCacheNameDetails.mjs';
import {skipWaiting as workbox_core_skipWaiting} from '/opt/build/repo/node_modules/workbox-core/skipWaiting.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/opt/build/repo/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */





workbox_core_setCacheNameDetails({prefix: "wasm-by-example%%1665942799498%%"});


workbox_core_skipWaiting();




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "about.html",
    "revision": "426216006d53d1cff9cac6ae007d48be"
  },
  {
    "url": "additional-resources.html",
    "revision": "dbcdf4b3f4888addfbe2925474f486c5"
  },
  {
    "url": "all-examples-list.html",
    "revision": "8898f4c00eae3b6d18cbcf62dfc46638"
  },
  {
    "url": "demo-redirect.html",
    "revision": "7922554cab46114cd756c96f87935ccd"
  },
  {
    "url": "demo-util/domConsole.js",
    "revision": "b73740f1f992224b23ec5e3fd1f49fd3"
  },
  {
    "url": "demo-util/instantiateWasm.js",
    "revision": "ad2233de2cf720b54708891da6c224c2"
  },
  {
    "url": "example-redirect.html",
    "revision": "fc03c47f48824984cf7658c60fe1d375"
  },
  {
    "url": "examples/classes/classes.assemblyscript.en-us.html",
    "revision": "e9c69759a89a458f0a409a386243e347"
  },
  {
    "url": "examples/classes/demo/assemblyscript/ASBindTest.wasm",
    "revision": "6829977a57d2d585b0344560988d2885"
  },
  {
    "url": "examples/classes/demo/assemblyscript/index.js",
    "revision": "63260a781b994c32b76c19a65cddebe1"
  },
  {
    "url": "examples/classes/demo/assemblyscript/package-lock.json",
    "revision": "ecc0cb151efec5cef7483baeecb8a93f"
  },
  {
    "url": "examples/classes/demo/assemblyscript/package.json",
    "revision": "92cc4ae2b3ae1af4800007dc83fe2158"
  },
  {
    "url": "examples/exports/demo/assemblyscript/exports.js",
    "revision": "f4d8c73507f8b08bcdab859353486193"
  },
  {
    "url": "examples/exports/demo/assemblyscript/exports.wasm",
    "revision": "6e1344232df7a5e20785d8ac896d4784"
  },
  {
    "url": "examples/exports/demo/assemblyscript/index.html",
    "revision": "db18eabdaa368e4849c81c4dc2e2d3f3"
  },
  {
    "url": "examples/exports/demo/go/index.html",
    "revision": "822c4030121830424b79f6dd1730d890"
  },
  {
    "url": "examples/exports/demo/go/index.js",
    "revision": "161316fb9768f248114643844bf966cf"
  },
  {
    "url": "examples/exports/demo/go/main.wasm",
    "revision": "48138ad3f12e114b42935460bad30eb8"
  },
  {
    "url": "examples/exports/demo/go/wasm_exec.js",
    "revision": "3bffd845b8a3d36dea0a5ea9d6b707cd"
  },
  {
    "url": "examples/exports/demo/rust/index.html",
    "revision": "0828db27c3c5df9d181e7f4312f8eac3"
  },
  {
    "url": "examples/exports/demo/rust/index.js",
    "revision": "072d0410e279f9fceb5afb208a786d23"
  },
  {
    "url": "examples/exports/demo/rust/pkg/exports_bg.wasm",
    "revision": "c2cf20ce5ae5ba5f6b4edc747bf39f32"
  },
  {
    "url": "examples/exports/demo/rust/pkg/exports.js",
    "revision": "6b562ba1000bd1a38f04d20a2ac5c5e9"
  },
  {
    "url": "examples/exports/demo/rust/pkg/package.json",
    "revision": "6afd97fada88d7cf0921c16fec8a5673"
  },
  {
    "url": "examples/exports/exports.assemblyscript.en-us.html",
    "revision": "cd5a836979bf696ef961cc20629d0773"
  },
  {
    "url": "examples/exports/exports.go.en-us.html",
    "revision": "3c9bdfa75c6c55b4100ee47af2d017f8"
  },
  {
    "url": "examples/exports/exports.rust.en-us.html",
    "revision": "f2baabf94fcd9cbd945644eee83d2fa6"
  },
  {
    "url": "examples/exports/exports.rust.pt-br.html",
    "revision": "49c30be2fadcb5a187b837c7980c9848"
  },
  {
    "url": "examples/hello-world/demo/assemblyscript/hello-world.js",
    "revision": "99fb380bf06cb1d13489796092989674"
  },
  {
    "url": "examples/hello-world/demo/assemblyscript/hello-world.wasm",
    "revision": "23d4ffba96e760847065d87184d514a1"
  },
  {
    "url": "examples/hello-world/demo/assemblyscript/index.html",
    "revision": "6ec3df5435fd5cc220d1ca28d5f95b2e"
  },
  {
    "url": "examples/hello-world/demo/go/index.html",
    "revision": "f7f372040da8eddc3ac8e6d2504d9bd0"
  },
  {
    "url": "examples/hello-world/demo/go/index.js",
    "revision": "36713869b841e26aff6e37f5b0be4a75"
  },
  {
    "url": "examples/hello-world/demo/go/main.wasm",
    "revision": "c82cfd66959fa545e67be4e272440c95"
  },
  {
    "url": "examples/hello-world/demo/go/wasm_exec.js",
    "revision": "3bffd845b8a3d36dea0a5ea9d6b707cd"
  },
  {
    "url": "examples/hello-world/demo/rust/index.html",
    "revision": "2f8232ed89171975a4f078bc529ca356"
  },
  {
    "url": "examples/hello-world/demo/rust/index.js",
    "revision": "faf70a276330c8114a5d046924fb00a0"
  },
  {
    "url": "examples/hello-world/demo/rust/pkg/hello_world_bg.wasm",
    "revision": "b92f00a0637a42a612f21db723cdd7c0"
  },
  {
    "url": "examples/hello-world/demo/rust/pkg/hello_world.js",
    "revision": "b11c8c4efd71125a501621953eea1dbb"
  },
  {
    "url": "examples/hello-world/demo/rust/pkg/package.json",
    "revision": "72e04754c8b31936079d2374b121c6c6"
  },
  {
    "url": "examples/hello-world/hello-world.assemblyscript.en-us.html",
    "revision": "890175e4a085808281c161f037285783"
  },
  {
    "url": "examples/hello-world/hello-world.c.en-us.html",
    "revision": "213b72cb12ea8677f76afc4188bd75f3"
  },
  {
    "url": "examples/hello-world/hello-world.go.en-us.html",
    "revision": "083f2d90d18df938b058b6c63b247bc5"
  },
  {
    "url": "examples/hello-world/hello-world.rust.en-us.html",
    "revision": "724451ba4af54139806f47a1aeaf0bfa"
  },
  {
    "url": "examples/hello-world/hello-world.rust.pt-br.html",
    "revision": "836c8dfc4dfb1111f06902064c2d7f98"
  },
  {
    "url": "examples/importing-javascript-functions-into-webassembly/demo/assemblyscript/index.html",
    "revision": "e07904ce5c78d4a6a47b4d4cf9e28168"
  },
  {
    "url": "examples/importing-javascript-functions-into-webassembly/demo/assemblyscript/index.js",
    "revision": "94c8d08a571acf7fabc7071803a3c7af"
  },
  {
    "url": "examples/importing-javascript-functions-into-webassembly/demo/assemblyscript/index.wasm",
    "revision": "f2432d5895630ec11e1ffe617d4aebba"
  },
  {
    "url": "examples/importing-javascript-functions-into-webassembly/demo/go/index.html",
    "revision": "1eb6e319b8bb047841e9dc6ed5d142ab"
  },
  {
    "url": "examples/importing-javascript-functions-into-webassembly/demo/go/index.js",
    "revision": "cbb5cc2238217fda58ad02df2023df19"
  },
  {
    "url": "examples/importing-javascript-functions-into-webassembly/demo/go/main.wasm",
    "revision": "1defdb8648a047a5d07214039296d46c"
  },
  {
    "url": "examples/importing-javascript-functions-into-webassembly/demo/go/wasm_exec.js",
    "revision": "3bffd845b8a3d36dea0a5ea9d6b707cd"
  },
  {
    "url": "examples/importing-javascript-functions-into-webassembly/demo/rust/index.html",
    "revision": "1ec14a14d5b8811a44f8f0ef915d95f1"
  },
  {
    "url": "examples/importing-javascript-functions-into-webassembly/demo/rust/index.js",
    "revision": "a2ba6699a4b11aa5a1e120a3038f4250"
  },
  {
    "url": "examples/importing-javascript-functions-into-webassembly/demo/rust/pkg/importing_javascript_functions_into_webassembly_bg.wasm",
    "revision": "8c316719d029d313c1061469c30a7069"
  },
  {
    "url": "examples/importing-javascript-functions-into-webassembly/demo/rust/pkg/importing_javascript_functions_into_webassembly.js",
    "revision": "e6ab8c5d572c6e6959db423de789a0ba"
  },
  {
    "url": "examples/importing-javascript-functions-into-webassembly/demo/rust/pkg/package.json",
    "revision": "525f68e403a431b8a4b039f7aff8af90"
  },
  {
    "url": "examples/importing-javascript-functions-into-webassembly/importing-javascript-functions-into-webassembly.assemblyscript.en-us.html",
    "revision": "e1c832f73c4a6f696a414038e5a88d8d"
  },
  {
    "url": "examples/importing-javascript-functions-into-webassembly/importing-javascript-functions-into-webassembly.go.en-us.html",
    "revision": "9030a016d70cffa163df38e33e43b8da"
  },
  {
    "url": "examples/importing-javascript-functions-into-webassembly/importing-javascript-functions-into-webassembly.rust.en-us.html",
    "revision": "da7ae62f99a3f07534ca98f711fb5ed6"
  },
  {
    "url": "examples/importing-javascript-functions-into-webassembly/importing-javascript-functions-into-webassembly.rust.pt-br.html",
    "revision": "5885eb6996cde53f6c1d86a91636c0ee"
  },
  {
    "url": "examples/introduction/introduction.all.en-us.html",
    "revision": "496d32b3ac91ba199a0ededaac59ac78"
  },
  {
    "url": "examples/introduction/introduction.all.pt-br.html",
    "revision": "3a7df575e42d1ba985aac10f2e8f4c3b"
  },
  {
    "url": "examples/passing-high-level-data-types-with-as-bind/demo/assemblyscript/addWasmByExample.wasm",
    "revision": "e6e6551df26becc501044d1259d0a5a6"
  },
  {
    "url": "examples/passing-high-level-data-types-with-as-bind/demo/assemblyscript/assembly/tsconfig.json",
    "revision": "14a2b1497fa06167fec6e520fd397c37"
  },
  {
    "url": "examples/passing-high-level-data-types-with-as-bind/demo/assemblyscript/index.html",
    "revision": "339d671be3d7e5e9333aa62c0b81d19b"
  },
  {
    "url": "examples/passing-high-level-data-types-with-as-bind/demo/assemblyscript/index.js",
    "revision": "2edddf94925c5c1def4e3d9c445d9ae0"
  },
  {
    "url": "examples/passing-high-level-data-types-with-as-bind/demo/assemblyscript/package-lock.json",
    "revision": "ecc0cb151efec5cef7483baeecb8a93f"
  },
  {
    "url": "examples/passing-high-level-data-types-with-as-bind/demo/assemblyscript/package.json",
    "revision": "294d227f5aac682cb90e7d2babd91262"
  },
  {
    "url": "examples/passing-high-level-data-types-with-as-bind/demo/assemblyscript/tests/index.js",
    "revision": "242789ab2671cce0520d2afbf5c29c49"
  },
  {
    "url": "examples/passing-high-level-data-types-with-as-bind/passing-high-level-data-types-with-as-bind.assemblyscript.en-us.html",
    "revision": "e4a7d840de79b4d6e1f2e3c833e1cda7"
  },
  {
    "url": "examples/passing-high-level-data-types-with-wasm-bindgen/demo/rust/index.html",
    "revision": "b2668298db442136a6c87f2f8808c219"
  },
  {
    "url": "examples/passing-high-level-data-types-with-wasm-bindgen/demo/rust/index.js",
    "revision": "aacff550557510986ae4d87cd34c84b2"
  },
  {
    "url": "examples/passing-high-level-data-types-with-wasm-bindgen/demo/rust/pkg/package.json",
    "revision": "5b69ccf8584919b86488db856048c2eb"
  },
  {
    "url": "examples/passing-high-level-data-types-with-wasm-bindgen/demo/rust/pkg/strings_bg.wasm",
    "revision": "d2b114101fc2952269c181365f2e09be"
  },
  {
    "url": "examples/passing-high-level-data-types-with-wasm-bindgen/demo/rust/pkg/strings.js",
    "revision": "34817f5628059c941e355d8bc46060c4"
  },
  {
    "url": "examples/passing-high-level-data-types-with-wasm-bindgen/passing-high-level-data-types-with-wasm-bindgen.rust.en-us.html",
    "revision": "7eb7e9623e53170f9b6243533e4b64ef"
  },
  {
    "url": "examples/passing-high-level-data-types-with-wasm-bindgen/passing-high-level-data-types-with-wasm-bindgen.rust.pt-br.html",
    "revision": "7c2e51bcd307ae76737e0b2b092b85c0"
  },
  {
    "url": "examples/reading-and-writing-audio/demo/assemblyscript/index.html",
    "revision": "f144849a39f2195434548e1a866fbb59"
  },
  {
    "url": "examples/reading-and-writing-audio/demo/assemblyscript/index.js",
    "revision": "2ff7fb69d998ed319c037207e13250fa"
  },
  {
    "url": "examples/reading-and-writing-audio/demo/assemblyscript/index.wasm",
    "revision": "2b144c57b0e56dec702316eff82c6bc4"
  },
  {
    "url": "examples/reading-and-writing-audio/demo/go/index.html",
    "revision": "844f22b4cd3022bc6a4caf8d3c6a9227"
  },
  {
    "url": "examples/reading-and-writing-audio/demo/go/index.js",
    "revision": "80114c33e7c32aeee750516e9af1083a"
  },
  {
    "url": "examples/reading-and-writing-audio/demo/go/main.wasm",
    "revision": "1455b8798905970e2d2fb0696991952b"
  },
  {
    "url": "examples/reading-and-writing-audio/demo/go/wasm_exec.js",
    "revision": "3bffd845b8a3d36dea0a5ea9d6b707cd"
  },
  {
    "url": "examples/reading-and-writing-audio/demo/rust/index.html",
    "revision": "59f21a9015ec6ada252cac30ef5c48ef"
  },
  {
    "url": "examples/reading-and-writing-audio/demo/rust/index.js",
    "revision": "8adc216e266d6a28053715eb12f8e89b"
  },
  {
    "url": "examples/reading-and-writing-audio/demo/rust/pkg/audio_bg.wasm",
    "revision": "14319a8c9a7b29a3db4c89b74abb275c"
  },
  {
    "url": "examples/reading-and-writing-audio/demo/rust/pkg/audio.js",
    "revision": "c2fa980f4b85cd75ce93a2c50d1a0461"
  },
  {
    "url": "examples/reading-and-writing-audio/demo/rust/pkg/graphics_bg.wasm",
    "revision": "14319a8c9a7b29a3db4c89b74abb275c"
  },
  {
    "url": "examples/reading-and-writing-audio/demo/rust/pkg/graphics.js",
    "revision": "ce75d2c5fa56ae569e9774a7b7fefad5"
  },
  {
    "url": "examples/reading-and-writing-audio/demo/rust/pkg/package.json",
    "revision": "cb3639047b45bee5d1ddf05f6256ecf0"
  },
  {
    "url": "examples/reading-and-writing-audio/reading-and-writing-audio.assemblyscript.en-us.html",
    "revision": "b5cbd91d51722baf0e67db709d1c3f4a"
  },
  {
    "url": "examples/reading-and-writing-audio/reading-and-writing-audio.go.en-us.html",
    "revision": "228609a22888334859232b815b24b733"
  },
  {
    "url": "examples/reading-and-writing-audio/reading-and-writing-audio.rust.en-us.html",
    "revision": "5adc0b3242e4a43c76d016fbae6a1d3d"
  },
  {
    "url": "examples/reading-and-writing-audio/reading-and-writing-audio.rust.pt-br.html",
    "revision": "b4c8d526d4a005dbbe602a0617f3f0f3"
  },
  {
    "url": "examples/reading-and-writing-graphics/demo/assemblyscript/index.html",
    "revision": "7c5134ff76fec574bae1c5b493ddcc51"
  },
  {
    "url": "examples/reading-and-writing-graphics/demo/assemblyscript/index.js",
    "revision": "c836acde9f84e84f7d2bbed35b0a4498"
  },
  {
    "url": "examples/reading-and-writing-graphics/demo/assemblyscript/index.wasm",
    "revision": "5a3719c7c0b677356cf2eda975150121"
  },
  {
    "url": "examples/reading-and-writing-graphics/demo/go/index.html",
    "revision": "0b7aa33c60bed0a909252aa676c25b77"
  },
  {
    "url": "examples/reading-and-writing-graphics/demo/go/index.js",
    "revision": "7528b86b38ae60b48df17c9691398936"
  },
  {
    "url": "examples/reading-and-writing-graphics/demo/go/main.wasm",
    "revision": "510cc0aec231f1ae232a56f66e1e48f9"
  },
  {
    "url": "examples/reading-and-writing-graphics/demo/go/wasm_exec.js",
    "revision": "3bffd845b8a3d36dea0a5ea9d6b707cd"
  },
  {
    "url": "examples/reading-and-writing-graphics/demo/rust/index.html",
    "revision": "a5aa53ab05bc81c80630c9647cedf1df"
  },
  {
    "url": "examples/reading-and-writing-graphics/demo/rust/index.js",
    "revision": "b75a73edf9aa5b1298e302036ab8e32c"
  },
  {
    "url": "examples/reading-and-writing-graphics/demo/rust/pkg/graphics_bg.wasm",
    "revision": "9e20a6924098eb38153be89dcd295cfb"
  },
  {
    "url": "examples/reading-and-writing-graphics/demo/rust/pkg/graphics.js",
    "revision": "b8bbbea9e9410037e3be5806e32a296e"
  },
  {
    "url": "examples/reading-and-writing-graphics/demo/rust/pkg/package.json",
    "revision": "88364f500f61dcfc593c34389af9b6dc"
  },
  {
    "url": "examples/reading-and-writing-graphics/reading-and-writing-graphics.assemblyscript.en-us.html",
    "revision": "84fa79838301e8b1f1bb9d8424d90662"
  },
  {
    "url": "examples/reading-and-writing-graphics/reading-and-writing-graphics.go.en-us.html",
    "revision": "98176e1525a6f47151ceec93038ca100"
  },
  {
    "url": "examples/reading-and-writing-graphics/reading-and-writing-graphics.rust.en-us.html",
    "revision": "800af4443b90d22e2767ad0ad6bcfdf2"
  },
  {
    "url": "examples/reading-and-writing-graphics/reading-and-writing-graphics.rust.pt-br.html",
    "revision": "69faac5ab7a46daf5724250927c96a2f"
  },
  {
    "url": "examples/strings/demo/c/caesar.wasm",
    "revision": "131da5163312e4cceb8035da91ba0d4a"
  },
  {
    "url": "examples/strings/demo/c/index.html",
    "revision": "7af7faa4c79fc3079a5919dbabe62c22"
  },
  {
    "url": "examples/strings/strings.c.en-us.html",
    "revision": "1d2cd5ba6df46c7203a72bf6ba161682"
  },
  {
    "url": "examples/wasi-hello-world/demo/assemblyscript/build/index.wasm",
    "revision": "cd36656659c5e5473dcaa6e5ab42c4e1"
  },
  {
    "url": "examples/wasi-hello-world/demo/assemblyscript/package-lock.json",
    "revision": "c9d3e2a3b583aa502386ba10370d0d2d"
  },
  {
    "url": "examples/wasi-hello-world/demo/assemblyscript/package.json",
    "revision": "99bd73bf26455ac2e307fb5d1bbef10c"
  },
  {
    "url": "examples/wasi-hello-world/demo/go/main.wasm",
    "revision": "057208b0afdc0f9fd7b91cc69c6a23b7"
  },
  {
    "url": "examples/wasi-hello-world/wasi-hello-world.assemblyscript.en-us.html",
    "revision": "ff468281a3ed5ba4411cb1a5d300444b"
  },
  {
    "url": "examples/wasi-hello-world/wasi-hello-world.go.en-us.html",
    "revision": "2fe8a33b267757601a08ed77e6472493"
  },
  {
    "url": "examples/wasi-hello-world/wasi-hello-world.rust.en-us.html",
    "revision": "8ff41ebe090f99b31a6bce04e351e0d9"
  },
  {
    "url": "examples/wasi-hello-world/wasi-hello-world.rust.pt-br.html",
    "revision": "1b91857569c365ebd2579a36a90743e0"
  },
  {
    "url": "examples/wasi-introduction/wasi-introduction.all.en-us.html",
    "revision": "ff0d0a57372c759742f2fda472baa5d1"
  },
  {
    "url": "examples/wasi-introduction/wasi-introduction.all.pt-br.html",
    "revision": "e9535757fc9518911b0d71165c80b7c2"
  },
  {
    "url": "examples/webassembly-linear-memory/demo/assemblyscript/index.html",
    "revision": "81b700fddeb88090fc5cddabc33f824b"
  },
  {
    "url": "examples/webassembly-linear-memory/demo/assemblyscript/index.js",
    "revision": "e461bc5559d4ee0d3aa81fa5f1b48faa"
  },
  {
    "url": "examples/webassembly-linear-memory/demo/assemblyscript/index.wasm",
    "revision": "6cd0e45fff617db941800865853f1402"
  },
  {
    "url": "examples/webassembly-linear-memory/demo/go/index.html",
    "revision": "37dc3dd84d93b43490087011d2e975e9"
  },
  {
    "url": "examples/webassembly-linear-memory/demo/go/index.js",
    "revision": "2a6add3ce9422ff51afede91cc9e58fc"
  },
  {
    "url": "examples/webassembly-linear-memory/demo/go/main.wasm",
    "revision": "8f7431b5a9141b82f420d43125382c83"
  },
  {
    "url": "examples/webassembly-linear-memory/demo/go/wasm_exec.js",
    "revision": "3bffd845b8a3d36dea0a5ea9d6b707cd"
  },
  {
    "url": "examples/webassembly-linear-memory/demo/rust/index.html",
    "revision": "2f8232ed89171975a4f078bc529ca356"
  },
  {
    "url": "examples/webassembly-linear-memory/demo/rust/index.js",
    "revision": "23eeb0b6235f9000382640dcee813f8d"
  },
  {
    "url": "examples/webassembly-linear-memory/demo/rust/pkg/package.json",
    "revision": "add1277c5873c94b043f45d9a7fcf661"
  },
  {
    "url": "examples/webassembly-linear-memory/demo/rust/pkg/webassembly_linear_memory_bg.wasm",
    "revision": "1c3752b56a7f61a2b86899af1dbb2b88"
  },
  {
    "url": "examples/webassembly-linear-memory/demo/rust/pkg/webassembly_linear_memory.js",
    "revision": "ddbdde0b983c31c3d1198c49630c5a54"
  },
  {
    "url": "examples/webassembly-linear-memory/webassembly-linear-memory.assemblyscript.en-us.html",
    "revision": "923d671d659afaefd63c70a2fc58d925"
  },
  {
    "url": "examples/webassembly-linear-memory/webassembly-linear-memory.go.en-us.html",
    "revision": "f3b90b5ca4dd23938bc753d977ea8697"
  },
  {
    "url": "examples/webassembly-linear-memory/webassembly-linear-memory.rust.en-us.html",
    "revision": "c8ef3793375c373b44ce01f44ebad488"
  },
  {
    "url": "examples/webassembly-linear-memory/webassembly-linear-memory.rust.pt-br.html",
    "revision": "9499a938d3f4d6542268f0b1af3d2e6b"
  },
  {
    "url": "home.en-us.html",
    "revision": "d3dc61175e9e48c549a02a2bd5e99979"
  },
  {
    "url": "home.pt-br.html",
    "revision": "d3dc61175e9e48c549a02a2bd5e99979"
  },
  {
    "url": "icon-apple.png",
    "revision": "6a35bc5b72821018c633c76c057cb904"
  },
  {
    "url": "icon.png",
    "revision": "3f1006db0bcfd0c9b85f18142573bb10"
  },
  {
    "url": "index.html",
    "revision": "fcf381aaecc31b778165255fba0aeaa5"
  },
  {
    "url": "manifest.json",
    "revision": "319faa08e008203111da519b7127fed1"
  },
  {
    "url": "readmeBanner.png",
    "revision": "d6f601a3b7d82885ea7e910a819fcd00"
  },
  {
    "url": "source-redirect.html",
    "revision": "0695581a08fe586202df887f5e19c9e1"
  },
  {
    "url": "Web_Assembly_Logo.svg",
    "revision": "7736bb16970f14456275c5edca8b73b5"
  }
], {
  "ignoreURLParametersMatching": [/.*exampleName.*/, /.*example-name.*/]
});








